export class NavItem {
  constructor (
    public anchor: string,
    public title: string
  ) {}
}



// WEBPACK FOOTER //
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/nav/navItem.ts